<template>
<div>
    <b-row>
        <b-col cols="5">
            <b-card>
            <!-- table -->
            <b-form-group label="" label-for="payment-method">
                <b-input-group>
                    <b-form-input id="group_name" placeholder="組別名稱 Group Name" v-model="group_add" trim/>
                    <b-input-group-append>
                        <b-button variant="outline-primary" @click="add_group()">
                            增加 Add 
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            <b-table
                ref="selectableTable"
                selectable
                :select-mode="selectMode"
                :items="groups"
                :fields="fields"
                responsive
                striped
                class="mb-0"
                @row-selected="onRowSelected">
                <template #cell(actions)="data">
                    <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

                        <template #button-content>
                            <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body"/>
                        </template>
                        <b-dropdown-item :to="{ name: 'apps-Member-view', params: { id: data.item.id } }">
                            <feather-icon icon="FileTextIcon"/>
                            <span class="align-middle ml-50">Details</span>
                        </b-dropdown-item>

                        <b-dropdown-item :to="{ name: 'apps-Member-edit', params: { id: data.item.id } }">
                            <feather-icon icon="EditIcon"/>
                            <span class="align-middle ml-50">Edit</span>
                        </b-dropdown-item>

                        <b-dropdown-item>
                            <feather-icon icon="TrashIcon"/>
                            <span class="align-middle ml-50">Delete</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
                <template #cell(status_number)="data">
                    <b-badge :variant="status[1][data.value]">
                        {{ status[0][data.value] }}
                    </b-badge>
                </template>
            </b-table>
            </b-card>
        </b-col>
        <b-col cols="7">
            <b-card>
              <h5>{{  selected_group.name }}</h5>
                <b-row v-if="selected_group.name != null">
                    <b-col cols="4">
                      <div v-for="menu in menus" :key="menu.id">
                        <h6>{{ menu.name }}</h6>
                        <b-form-group>
                          <b-form-checkbox-group
                            v-model="selected_menu"
                            :options="menu.submenu"
                            value-field="value"
                            text-field="text"
                            switches
                            stacked
                          />
                        </b-form-group>
                      </div>
                    </b-col>
                    <b-col cols="5">  
                      <h6>Function Control</h6>
                        <b-form-group>
                            <b-form-checkbox-group
                                v-model="selected_function"
                                :options="functions"
                                switches
                                stacked
                                class="custom-control-success"
                            />
                            </b-form-group>
                    </b-col>
                    <b-col lg="3" md="12">  
                       <b-button block variant="primary" @click="save()">Save</b-button>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
var numeral = require('numeral');
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import router from '@/router'
import {BFormCheckbox,BFormCheckboxGroup,
  BCard,BTable, BAvatar, BCardBody, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend, BListGroup, BListGroupItem
} from 'bootstrap-vue'

export default {
  components: {
    router,
    BFormCheckboxGroup,
    BFormCheckbox,
    BBadge,
    BListGroup,
    BListGroupItem,
    BTable,
    BAvatar,
    ToastificationContent,
    BBadge,
    BCard,
    BRow,
    vSelect,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
    BPagination,
    BCardCode,
    BTable,
    BButton,
    BFormGroup,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
  },
  directives: {
    Ripple,
  },
  computed: {
  },
  data() {
    return {
      group_add: null,
      set_id: null,
      bar_add : {
        amount : null,
        percentage : null
      },
      selected_set_enable: true,
      packageOptions: [],
      paymentMethods:[],
      selectMode:'single',
      selected_group:{
        name: null,
        id: null
      },
      selected_menu:[],
      groups:[],
      selected_function:[],
      isAddNewPackageSidebarActive: false,
      searchString: null,
      menus:[],
      fields: [{ key: 'name', label: 'Group Name' }],
      /* eslint-disable global-require */
      items: [],

    }
  },

  watch: {

  },
  created() {
    this.get_menu_functions()
    this.get_groups()
  },
  methods: {
    add_group() {
this.$http.post(process.env.VUE_APP_API_BASE+`/group/add/`,{
        "name":this.group_add ,
        })
        .then(res => {
            if (res.data.result === true) {
                    this.get_groups()

            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    save() {
        if (!this.selected_group) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: "請先選擇組別",
              },
            })
            return;
        }
      this.$http.post(process.env.VUE_APP_API_BASE+`/permission/save/`,{
        group_id:this.selected_group.id ,
        menus: this.selected_menu,
        functions : this.selected_function
    })
        .then(res => {
            if (res.data.result === true) {
              this.get_menu_functions()
              this.get_groups()
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.get_menu_functions()
    this.get_groups()
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    to_numeral(number) {
      return numeral(number).format('0,0.00')
    },
    get_payment_method() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/payments/')
        .then(res => {
          this.paymentMethods = res.data
        })
    },
    one() {
      this.isAddNewPackageSidebarActive = false
      this.get_data()
    },
    get_menu_functions() {
       this.$http.get(process.env.VUE_APP_API_BASE+`/menu_functions/?lang=`+this.$i18n.locale)
         .then(res => {
           this.menus = res.data.menus
           this.functions = res.data.functions
         })
    },
    get_groups() {
       this.$http.get(process.env.VUE_APP_API_BASE+`/groups/`)
         .then(res => {
           this.groups = res.data.groups
         })
    },
    get_commission_set(set) {
      this.set_id = set[0].id
       this.$http.get(process.env.VUE_APP_API_BASE+`/commissions/set/`+set[0].id+`/`)
         .then(res => {
           this.selected_set_enable = false
           this.selected_set = res.data.records
         })
    },
    handleChangePage() {

    //  this.get_data()
    },
    onRowSelected(items) {
        if (items[0].id == this.selected_group && this.selected_group.id) { 
          return
        }
        this.selected_menu =  []
        this.selected_function = []
        this.selected_group = items[0]
        let arr = null
        if (items[0].menus !== null && items[0].menus !== undefined &&items[0].menus !== '') {
            arr = items[0].menus.split(',').map(Number);
            this.selected_menu = arr
        }
        if (items[0].functions !== null && items[0].functions!== undefined &&items[0].functions !== '') {
            arr = items[0].functions.split(',').map(Number);
            this.selected_function = arr
        }
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    selectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.selectRow(2)
    },
    unselectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.unselectRow(2)
    },

    handleSearch() {
      // let _print = `The user searched for: ${searching}\n`
      // this.$refs.pre.appendChild(document.createTextNode(_print))
    // this.searchString = searching
    // this.currentx = 1
    // this.get_data()
      this.searchTimeOut()
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        // your code
        this.currentPage = 1
        this.get_data()
      }, 500)
    },
  },
}
</script>

<style lang="scss">
.b-table-selectable{
  .feather{
    font-size: 1.3rem;
  }
}

</style>
